<template>
    <BaseRadioGroup
        v-model="localValue"
        :radios="list"
        class="radio-groups">
    </BaseRadioGroup>
</template>

<script>
export default {
    props: ['value', 'type'],
    data () {
        return {
            list: [
                {
                    value: '1',
                    label: this.$t('general.enabled'),
                },
                {
                    value: '0',
                    label: this.$t('general.disabled'),
                }
            ],
            localValue: '1'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (newV) {
                this.localValue = newV
            }
        },
        localValue (newV) {
            this.$emit('input', newV)
        }
    }
}
</script>

<style scoped>
.radio-groups {
    @apply flex;
}
.radio-groups ::v-deep .vc-form-radio:last-child {
    @apply ml-8;
}
</style>